var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewCopyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.873,
    height: 17.838,
    viewBox: "0 0 17.873 17.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2925",
    "data-name": "Rectangle 2925",
    width: 17.873,
    height: 17.838,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16070",
    "data-name": "Group 16070",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16069",
    "data-name": "Group 16069",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10773",
    "data-name": "Path 10773",
    d: "M17.853,8.246c0-.02,0-.02-.02-.04,0-.02-.02-.04-.04-.06a.019.019,0,0,0-.02-.02c-.02-.02-.04-.06-.06-.079L14.735,5.068a.274.274,0,0,0-.079-.06h-.02c-.02-.02-.04-.02-.06-.04h-.02c-.02,0-.04-.02-.06-.02H10.922V3.361c0-.02-.02-.04-.02-.06s0-.02-.02-.04c0-.02-.02-.04-.04-.06a.02.02,0,0,0-.02-.02c-.02-.02-.04-.059-.06-.079L7.785.124a.271.271,0,0,0-.079-.06h-.02c-.02-.02-.04-.02-.06-.04h-.02c-.02,0-.04-.02-.06-.02H.5A.439.439,0,0,0,0,.461V12.376a.492.492,0,0,0,.5.5H6.951v4.468a.492.492,0,0,0,.5.5h9.929a.492.492,0,0,0,.5-.5V8.305a.073.073,0,0,1-.02-.06M14.894,6.617l1.291,1.291H14.894ZM7.943,1.653,9.234,2.944H7.943ZM6.951,5.426V11.88H.993V.958H6.951V3.44a.492.492,0,0,0,.5.5H9.929v.993H7.447a.492.492,0,0,0-.5.5M16.88,16.845H7.943V5.922H13.9V8.4a.492.492,0,0,0,.5.5H16.88Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCopyIcon);
export default __webpack_public_path__ + "static/media/NewCopyIcon.ec390bcd7a89a89bef768bf0292d223a.svg";
export { ForwardRef as ReactComponent };